import { FC, useState } from "react";
import { SlSocialVkontakte, SlSocialInstagram } from "react-icons/sl";

import styles from "./MessengerIcon.module.scss";
import { CommunicationItem } from "../../../utils";

interface MessengerIconProps {
  messenger: CommunicationItem;
}

export const MessengerIcon: FC<MessengerIconProps> = ({ messenger }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <a
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      href={messenger.link}
      target="_blank"
    >
      {messenger.type === "vk" ? (
        <div className={styles.communicationItem}>
          <SlSocialVkontakte
            size="1.5rem"
            color={isHover ? "#7bdcb5" : "white"}
          />
        </div>
      ) : (
        <div className={styles.communicationItem}>
          <SlSocialInstagram
            size="1.1rem"
            color={isHover ? "#7bdcb5" : "white"}
          />
        </div>
      )}
    </a>
  );
};
